import { Link } from 'components/router';
import { Heading, Microcopy, Text } from 'components/typography';
import * as React from 'react';

type PromotionalCardProps = {
  byline?: string;
  className?: string;
  description: string;
  heading?: string;
  href: string;
  imageUrl: string;
  linkText?: string;
  title: string;
};

const PromotionalCard = ({
  byline,
  className = '',
  description,
  heading,
  href,
  imageUrl,
  linkText,
  title,
  ...props
}: PromotionalCardProps): React.ReactNode => {
  return (
    <Link href={href} className={`group block ${className}`} {...props}>
      {heading && (
        <Heading size="l" className="mb-4">
          {heading}
        </Heading>
      )}
      <div className="flex w-full justify-start">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={imageUrl} alt="" aria-hidden />
      </div>
      <div className="pr-3 pt-4">
        {byline && (
          <Microcopy
            size="s"
            className="mb-1 font-bold uppercase text-gray-500"
          >
            {byline}
          </Microcopy>
        )}
        <Heading
          size="m"
          className="mb-4 transition-colors group-hover:text-gray-700"
        >
          {title}
        </Heading>
        <Text size="m" className="text-gray-900">
          {description}
        </Text>
        {linkText && (
          <Text
            size="m"
            className="mt-4 font-bold underline group-hover:text-gray-700"
          >
            {linkText}
          </Text>
        )}
      </div>
    </Link>
  );
};

export default PromotionalCard;
